import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import {getFontAwesomeClassName} from "../../../other/utils/utils.jsx";
import SwivuSettingsCombo from "./SwivuSettingsCombo.jsx";

export class SwivuIconsField extends SwivuSettingsCombo {
  static get type() {
    return WIDGET_KEYS.fieldIcon;
  }

  onChange({ value, oldValue, source }) {
    let oldRecord, newRecord = null;

    if (oldValue) {
      oldRecord = getFontAwesomeClassName(source.store.getById(oldValue)?.tagValue);
    }

    if (value) {
      newRecord = getFontAwesomeClassName(source.store.getById(value)?.tagValue).trim();
    }

    const inputEl = this.element.querySelector(".icon-label");

    if (oldRecord) {
      oldRecord.split(" ").forEach((item) => {
        inputEl.classList.remove(item);
      });
      // if we have a placeholder and no icon selected, the placeholder doesn't align to field start
      inputEl.classList.remove("pl-5");
    }

    if (newRecord) {
      newRecord.split(" ").forEach((item) => {
        inputEl.classList.add(item);
      })
      // adding padding so if icon is selected then icon should not go off the field
      inputEl.classList.add("pl-5");
    }
  }
  get innerElements() {
    return [
      { className: "icon-label", tag: "span" }, // use DomConfig here to create an icon
      ...super.innerElements
    ];
  }

  static get configurable() {
    return {
      clearable: false,
      listItemTpl: (record) => {
        return `
          <div style="display:flex; flex: 1; margin-left: 0.5em;">
             <i class="fa ${getFontAwesomeClassName(record.tagValue)}"></i>
          </div>
      `
      },
      displayValueRenderer: () => ""
    };
  }
}

SwivuIconsField.initClass();
